import logo_daee from '../../../../../../../../images/logo_daee_aparado.png'
import('./chart.css')

export default function Chart(opts){
    let current_options = opts.current_options
    let measurements
    BaseConstructor.call(this)

    this.generate = (chart, measurements, period) =>{
        generateViewChartFlu(chart,measurements,period)
    }

    function generateViewChartFlu(chart,m,period){
        measurements = m
        // let current_options = offcanvasOptions.getCurrentOptions()

        //gerando série para chart
        let SERIES = generateSeries(chart.series)

        //gerando lista de falhas
        let flaws = getFlaws(SERIES, undefined, 61,moment().subtract(period, 'minutes'))
        
        if(current_options.group_type != 'day'){
            //adicionando falhas na série
            addFlawsToSeries(SERIES, flaws)
            
            addFlawSeriesToSeries(SERIES,flaws)
        }

        if(Object.keys(flaws).length > 0){
            addFlawControlToSeries(SERIES)
        }

        let plotlines = generatePlotLines(chart.series)

        let container = document.getElementById(`chart_${chart.chart_name}`)
        chart = Highcharts.chart({
            chart:{
                renderTo: container,
                type: 'line',
                zoomType: "x",
                show_flaws: true
            },
            title: {
                text: '',
                // margin: 40,
                // useHTML: true
            },
        
            xAxis: {
                type: 'datetime',
                crosshair: true,
            },
        
            yAxis: [
                {
                    title: {
                        text: 'Nível'
                    },
                    labels: {
                        formatter: function() {
                            // if (value_type === 'm') {
                            //     // convert cm to m
                            //     return (this.value / 100).toFixed(3) + ' m';
                            // } else {
                            //     return this.value + ' cm';
                            // }
                            return (this.value / 100).toFixed(3) + ' m';
                        }
                    },
                    plotLines: plotlines['level'],
                    id: 'level'
                },
                {
                    title: {
                        text: 'Vazão (m³/s)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    plotLines: plotlines['flow'],
                    opposite: true,
                    id:'flow'
                },
                {
                    title: {
                        text: 'Chuva (mm)'
                    },
                    labels: {
                        format: '{value}'
                    },
                    //plotLines: plotlines['flow'],
                    id:'rain'
                }
            ],
            tooltip: {
                shared: true,
                formatter: function (e) {
                    function getFormat(){
                        // let current_options = offcanvasOptions.getCurrentOptions()
                        if(current_options.group_type == 'day'){
                            return 'DD/MM/YYYY'
                        } else {
                            return 'DD/MM/YYYY HH:mm'
                        }
                    }
                    function generateValue(context){
                        if(context.total){
                            let text = ""
                            if(context.total <= 59){
                                text = context.total + " min"
                            } else {
                                text = (context.total/60).toFixed(1) + " h"
                            }
                            return  text
                        } else if(context.series.userOptions.value_type == 'rain') { //série de chuva
                            return context.y +" mm"
                        } else if(context.series.userOptions.value_type == 'flow') { //série de chuva
                            return context.y +" m³/s"
                        } else {
                            return context.y +" cm"
                        }
                    }

                    let html = '<b>' + moment(this.x).format(getFormat()) + '</b><br>'
                    $.each(this.points, function(index, point){
                        let text = ""
                        let name = point.series.userOptions.name
                        text += name+': <b><span style="color:'+ point.color +'">' + generateValue(this) +'</span></b><br/>'               
                        html += text;
                    })
                    return html
                },
            },
            plotOptions: {
                series: {
                    connectNulls: false,
                    events: {
                        legendItemClick: function () {
                            // console.log(this.userOptions);
                            //estado atual da série
                            let current_visibility = this.visible

                            //estado atual do controlador de flaws
                            let show_flaws = this.chart.userOptions.chart.show_flaws

                            //todas as séries do chart
                            let series = this.chart.series
                            
                            //filtrando série com className == 'flaw'
                            let flaw_series = series.filter(x=>x.userOptions.className == 'flaw')

                            if(this.userOptions.station_prefix_id){  
                                //filtrando série com className == 'flaw' e do posto referente a legend
                                let serie = flaw_series.filter(x=>x.userOptions.className == 'flaw' && x.userOptions.station_prefix_id == this.userOptions.name)[0]

                                //setando a visibilidade das falhas desse posto
                                if(show_flaws){
                                    serie.setVisible(!current_visibility)
                                }

                                //variavel de auxilio para facilitar a informação se a série 'referencia' esta exibida ou nao
                                serie.userOptions.current_visibility = !current_visibility

                            } else if(this.userOptions.className == 'flaw-control'){
                                
                                //setando a visibilidade de cada série de falha
                                flaw_series.forEach(flow_serie=>{
                                    if(flow_serie.userOptions.current_visibility && !current_visibility){
                                        flow_serie.show()
                                    } else {
                                        flow_serie.hide()
                                    }
                                })

                                this.chart.userOptions.chart.show_flaws = !current_visibility
                            }

                            return true
                        }
                    }
                }
            },
        
            series: SERIES,
        
            responsive: {
                rules: [{
                    condition: {
                        // maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            // layout: 'horizontal',
                            // align: 'center',
                            // verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        
        });
        
        
    }

    function generateSeries(series_options = {}){

        let series = []
        let by_station = {}
        let by_station_plu = {}
        if(measurements.length > 0){
            measurements.forEach(measurement =>{
                let name = measurement.prefix.toUpperCase() + " - " + measurement.station_name.toUpperCase() + " - " + measurement.transmission_type_name.toUpperCase()
                if(by_station[name] == undefined){
                    by_station[name] = {level: [], flow: [], rain:[], station_prefix_id: measurement.station_prefix_id}
                    by_station_plu[name] = {level: [], flow: [], rain:[], station_prefix_id: measurement.station_prefix_id}
                }
                if(measurement.station_type_id == 1){
                    let show_level = _.get(series_options, 'level.options.show')
                    let show_flow = _.get(series_options, 'flow.options.show')
                    if(!show_level || show_level == 'true'){
                        by_station[name].level.push([moment(measurement.date, getFormatByGroupType()).valueOf(), parseFloat(measurement.value.toFixed(3))])
                    }
                    if(!show_flow || show_flow == 'true'){
                        if(measurement.read_value_flu > 0){
                            by_station[name].flow.push([moment(measurement.date, getFormatByGroupType()).valueOf(), parseFloat(measurement.read_value_flu.toFixed(3))])
                        }
                    }
                    
                } else if(measurement.station_type_id == 2){
                    by_station_plu[name].rain.push([moment(measurement.date, getFormatByGroupType()).valueOf(), parseFloat(measurement.value.toFixed(3))])
                }
                
            })

            $.each(by_station, (name, data)=>{
                [
                    ['level', ' - NÍVEL', 0],
                    ['flow', ' - VAZÃO', 1],
                    // ['rain', ' - CHUVA', 2, 'column'],
                ].forEach(config=>{
                    if(data[config[0]].length > 0){
                        series.push(
                            {
                                name: name + config[1],
                                data: data[config[0]],
                                station_prefix_id: data.station_prefix_id,
                                color: _.get(series_options, `${config[0]}.color`, null),
                                value_type: config[0],
                                yAxis: config[2],
                                type: config[3] ? 'column' : 'line'
                            }
                        );
                    }
                })
            })

            if(_.get(series_options, 'rain.options.show') == 'true' || _.get(series_options, 'rain.options.show') == undefined){
                if(_.get(series_options, 'rain.options.grouped') == 'true'){
                    by_station_plu = groupPluData(by_station_plu)
                }
      
                $.each(by_station_plu, (name, data)=>{
                    [
                        ['rain', ' - CHUVA', 2, 'column'],
                    ].forEach(config=>{
                        if(data[config[0]].length > 0){
                            series.push(
                                {
                                    name: name + config[1],
                                    data: data[config[0]],
                                    station_prefix_id: data.station_prefix_id,
                                    color: _.get(series_options, `${config[0]}.options.series_color`, null),
                                    value_type: config[0],
                                    yAxis: config[2],
                                    type: config[3] ? 'column' : 'line'
                                }
                            );
                        }
                    })
                })  
            }           
        }
        return series
    }
    
    function groupPluData(by_station_plu){
        let measurements = {}
        $.each(by_station_plu, (name, data)=>{
            data.rain.forEach(value=>{
                if(!measurements[value[0]]){
                    measurements[value[0]] = []
                }
                measurements[value[0]].push(value[1])
            })
        })
        by_station_plu = {}
        by_station_plu[""] = {rain:[], station_prefix_id: ''}
        $.each(measurements, (timestamp, m) =>{
            by_station_plu[""].rain.push([parseInt(timestamp), _.mean(m)])
        })
        return by_station_plu
    }

    function getFlaws(measurements, period, transmission_time, start_date){

        let start = start_date || new Date(current_options.start_date)

        let end = setEndDate()
        
        let start_ms = start.valueOf()
        let end_ms = end.valueOf()
        let prev_date = null
        let prev_value = null
        let flaws = {}

        $.each(measurements, function(index, obj){
            if(!obj.value_type || obj.value_type != 'rain'){
                flaws[obj.name] = {values: [], name: obj.name }
                $.each(obj.data, function(index, measurement){
                    // console.log(measurement,transmission_time);
                    if(prev_date != null){
                        let date = measurement[0]
                        let mss = date - prev_date
                        let diff_in_minutes = Math.floor((mss/1000)/60);
                        // console.log(diff_in_minutes);
                        if(diff_in_minutes > transmission_time){
                            flaws[obj.name].values.push([prev_date, date, prev_value,measurement[1],diff_in_minutes])
                        }
                        prev_date = measurement[0]
                        prev_value = measurement[1]
                    } else {
                        prev_date = measurement[0]
                        prev_value = measurement[1]
                        let mss = prev_date - start_ms
                        let diff_in_minutes = Math.floor((mss/1000)/60);
                        if(diff_in_minutes > transmission_time){
                            flaws[obj.name].values.push([start_ms, prev_date, measurement[1],measurement[1],diff_in_minutes])
                        }
                    }
                })
                let mss = end_ms - prev_date
                let diff_in_minutes = Math.floor((mss/1000)/60);

                if(diff_in_minutes > transmission_time){
                    flaws[obj.name].values.push([prev_date, end_ms, prev_value,prev_value,diff_in_minutes])
                }     
            }
        })
        
        // console.log('flaws', flaws)
        return flaws
    }

    function addFlawsToSeries(series, series_flaws){
        $.each(series_flaws, function(name, flaws){
            if(flaws.values.length > 0){
                // console.log(flaws);
                series.forEach(serie=>{
                    if(serie.name == name){
                        flaws.values.map(flaw=>serie.data.push([flaw[0]+1, null]))
                        serie.data.sort((a,b)=> a[0]-b[0])
                        // flaws.map(flaw=>serie.data.push([flaw[1]-1, 10]))

                        // [moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(measurement.value.toFixed(3))]
                    }
                })
            }
        })
    }
    //adicionando séries de falhas na lista de séries
    function addFlawSeriesToSeries(SERIES, flaws){
        $.each(flaws, (station_prefix_id, flaw_list)=>{
            let serie = []
            flaw_list.values.forEach(flaw=>{
                serie.push({x:flaw[0], y:parseFloat(flaw[2].toFixed(3)), total: flaw[4]})
                serie.push({x:flaw[1], y:parseFloat(flaw[3].toFixed(3)), total: flaw[4]})
                serie.push({x:flaw[1]+1, y:null})
            })
            let type = flaw_list.name.split(" - ")[flaw_list.name.split(" - ").length - 1]
            
            SERIES.push(
                {
                    name: 'FALHA - ' + flaw_list.name,
                    data: serie,
                    className: "flaw",
                    station_prefix_id: station_prefix_id,
                    color: "#f74f78",
                    dashStyle: "ShortDash",
                    enableMouseTracking: true,
                    showInLegend: false,
                    current_visibility: true,
                    yAxis: ((type == "NÍVEL") ? 0 : 1)
                }
            );
        })
    }

    function addFlawControlToSeries(SERIES){
        SERIES.push({
            name: 'FALHAS',
            className: "flaw-control",
            color: "#f74f78"
        })
    }

    function getFormatByGroupType(){
        // let current_options = offcanvasOptions.getCurrentOptions()
        if(current_options.group_type != "day"){
            return "YYYY-MM-DDTHH:mm:ss.SSSZ"
        } else {
            return "YYYY-MM-DD"
        }
        
    }

    function setEndDate(){
        // let current_options = offcanvasOptions.getCurrentOptions()
        let today = moment().format("yyyy-MM-DD")
        let end = moment(current_options.end_date).subtract(3, 'hours').format("yyyy-MM-DD")
        let end_date = undefined
        if(today == end){
            //deve ser esperadas medições até o horario atual
            end_date = new Date()
            end_date.setMinutes(0,0,0)
        } else {
            //deve ser esperadas medições até o fim do dia
            end_date = new Date(end)
            end_date.setHours(23)
            end_date.setMinutes(59,0,0)            
        }
        return end_date
    }

    function generatePlotLines(series_options){
        let plotlines = {}
        $.each(series_options, (type, data)=>{
            plotlines[type] = []
            if(data.reference_values && data.reference_values.fields && (!data.reference_values.show || data.reference_values.show == 'true')){
                $.each(data.reference_values.fields, (field, options)=>{
                    if(options.options.value && (!options.show || options.show == 'true')){
                        plotlines[type].push({
                            value: parseFloat(options.options.value),
                            color: options.options.color || 'red',
                            dashStyle: 'shortdash',
                            width: 2,
                            zIndex: 5,
                            label: {
                                text: field
                            }
                        })
                    }
                })
            }
        })
        return plotlines
    }
}

Chart.prototype = Object.create(BaseConstructor.prototype)